var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{staticClass:"system-message",attrs:{"index":"1"}},[_c('template',{slot:"title"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }